import React from 'react'
import { getPluralization } from 'src/Utils/globalHelpers'
import {
  ProgressMeterContainer,
  ProgressMeterTitle,
  StyledProgressBar,
} from './ProgressMeter.styles'

const MAX_PROGRESS_PERCENTAGE = 25

/**
 * Docs: https://react-bootstrap.netlify.app/docs/components/progress/
 *
 * @param fillPercentage - number
 * @param isStriped      - boolean
 * @param isAnimated     - boolean; If animated is on, striped is on by default
 * @returns
 */
export const ProgressMeter = ({
  fillPercentage = 0,
  isStriped = false,
  isAnimated = false,
}: {
  fillPercentage: number
  isStriped?: boolean
  isAnimated?: boolean
}): JSX.Element => (
  <StyledProgressBar
    now={fillPercentage}
    label={
      fillPercentage >= MAX_PROGRESS_PERCENTAGE ? `${fillPercentage}%` : ''
    } // hide label for small values
    striped={isStriped}
    animated={isAnimated}
  />
)

export const ProgressMeterWithText = ({
  progress,
  progressMax,
  noun,
  description,
  fontSize,
  fontWeight,
  isDim,
  verb,
}: {
  progress: number
  progressMax: number
  noun: string
  description?: string
  fontSize?: number
  fontWeight?: number
  isDim?: boolean
  verb?: string
}): JSX.Element => {
  const percentage = progress / (progressMax || 100)
  const fill = Math.round(percentage ? percentage * 100 : 0)

  return (
    <ProgressMeterContainer>
      <ProgressMeterTitle
        $fontSize={fontSize}
        $fontWeight={fontWeight}
        $isDim={isDim}
      >
        {verb || 'Scanning...'} {progress} of {progressMax}{' '}
        {getPluralization(noun, progressMax)} evaluated
      </ProgressMeterTitle>
      <ProgressMeter fillPercentage={fill} />
      <p>{description}</p>
    </ProgressMeterContainer>
  )
}
